__turbopack_context__.v({
  "copyBtn": "BrandColors-module__m4x4ga__copyBtn",
  "description": "BrandColors-module__m4x4ga__description",
  "downloadBtn": "BrandColors-module__m4x4ga__downloadBtn",
  "inner": "BrandColors-module__m4x4ga__inner",
  "leftCol": "BrandColors-module__m4x4ga__leftCol",
  "palette": "BrandColors-module__m4x4ga__palette",
  "row": "BrandColors-module__m4x4ga__row",
  "rowPrimary": "BrandColors-module__m4x4ga__rowPrimary",
  "section": "BrandColors-module__m4x4ga__section",
  "sectionTitle": "BrandColors-module__m4x4ga__sectionTitle",
  "tile": "BrandColors-module__m4x4ga__tile",
  "tileLight": "BrandColors-module__m4x4ga__tileLight",
  "tileName": "BrandColors-module__m4x4ga__tileName",
  "tileTop": "BrandColors-module__m4x4ga__tileTop",
  "tileValues": "BrandColors-module__m4x4ga__tileValues",
  "tileWide": "BrandColors-module__m4x4ga__tileWide",
  "value": "BrandColors-module__m4x4ga__value",
  "valueLabel": "BrandColors-module__m4x4ga__valueLabel",
});
